import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
import * as wjCell from '@mescius/wijmo.grid.cellmaker'
import { KeyAction, DataMap } from '@mescius/wijmo.grid'
// import { FlexGridPdfConverter, ScaleMode } from '@mescius/wijmo.grid.pdf'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import AddIcon from '@material-ui/icons/Add'
import Encoding from 'encoding-japanese'

import customContextMenu from '../../wijmo/customContextMenu'
import colElements from '../../wijmo/columnElements'
import editableFlexGridInitialize from '../../wijmo/editableFlexGridInitialize'
import FlexGridFileImport from '../input/FlexGridFileImport'

import { getNearestPrice, multiplyDecimals } from '../../utility'
import ErrorBoundary from '../ErrorBoundary'

function getLayoutDef (mode, newItemsCV, stampNoticeOptions, stampId) {
  const deleteButtonCol = {
    cssClassAll: 'wj-style-green',
    width: 80,
    isReadOnly: true,
    align: 'center',
    cellTemplate: wjCell.CellMaker.makeLink({
      text: '削除',
      href: 'javascript:void(0);',
      click: (e, cell) => { newItemsCV.remove(cell.item) },
      attributes: {
        class: 'btn ol-theme-primary py-0'
      }
    })
  }
  const isReadOnly = !['register', 'edit'].includes(mode)
  const ldTwoLines = [
    mode === 'edit'
      ? {
          colspan: 1,
          cells: [
            { ...colElements.id, rowspan: 2, width: 50, isReadOnly: true, cssClassAll: 'wj-style-basic' }
          ]
        }
      : null,
    {
      colspan: 2,
      cells: [
        { ...colElements.name, rowspan: 2, width: 250, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic-input' },
        { ...colElements.name_length }
      ]
    },
    {
      colspan: 2,
      cells: [
        { ...colElements.price, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic-input' },
        { ...colElements.rate_decimal, isReadOnly: isReadOnly, cssClassAll: 'wj-style-basic-input' },
        { ...colElements.royality, colspan: 2 }
      ]
    },
    {
      colspan: 4,
      cells: [
        (stampId === '000' || stampId === '999')
          ? { ...colElements.stamp_notice, isReadOnly: false, cssClassAll: 'wj-style-green-input', dataMap: new DataMap([stampId === '000' ? '印刷' : '免除']) }
          : { ...colElements.stamp_notice, isReadOnly: false, cssClassAll: 'wj-style-green-input', dataMap: new DataMap(stampNoticeOptions) },
        { ...colElements.ratio_stamp },
        { width: 15, cssClassAll: 'wj-style-green', isReadOnly: true, cellTemplate: (ctx) => '/' },
        { ...colElements.ratio_item, isReadOnly: isReadOnly, cssClassAll: 'wj-style-green-input' },
        { colspan: 4, cssClassAll: 'wj-style-green' }
      ]
    },
    {
      colspan: 2,
      cells: [
        { ...colElements.comment, isReadOnly: isReadOnly, cssClassAll: 'wj-style-green-input' },
        { ...colElements.comment_length }
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...deleteButtonCol, cellTemplate: mode === 'register' ? deleteButtonCol.cellTemplate : null }
      ]
    }
  ].filter(col => col)
  return {
    def: ldTwoLines,
    frozenColumns: 4
  }
}

//
export default function ItemsRegisterGrid (props) {
  const stampId = props.stampId.toString()
  const contract = props.contract
  const [newItemsCV, setNewItemsCV] = useState(null)
  const [layoutDef, setLayoutDef] = useState(null)
  const [jsonElem] = useState(props.itemsJsonId ? $('#' + props.itemsJsonId) : null)

  // インポート/エクスポート時のテーブルを定義
  const tableFormat = [
    { field: 'name', text: '商品名', type: 'string', isEditable: true, maxLength: colElements.name.maxLength },
    { field: 'price', text: '税抜小売価格', type: 'number', isEditable: true, maxLength: colElements.price.maxLength },
    { field: 'rate_decimal', text: '料率', type: 'number', isEditable: true, maxLength: colElements.rate_decimal.maxLength - 2, isRate: true },
    { field: 'royality', text: '使用料単価', type: 'number', isEditable: false },
    { field: 'stamp_notice', text: '証紙特記', type: 'string', isEditable: true },
    { field: 'ratio_stamp', text: '掛率証紙', type: 'number', isEditable: false },
    { field: 'ratio_item', text: '掛率数量', type: 'number', isEditable: true },
    { field: 'comment', text: '備考', type: 'string', isEditable: true, maxLength: colElements.comment.maxLength }
  ]

  const addItem = (cv) => {
    const item = {
      id: '',
      serial_no: '',
      name: '',
      price: 0,
      rate_decimal: contract.rate * 0.01,
      stamp_notice: stampId === '000' ? '印刷' : (stampId === '999' ? '免除' : '通常'),
      ratio_item: 1,
      comment: ''
    }

    cv.sourceCollection.push(item)
    cv.collectionChanged.raise(cv)
    cv.sortDescriptions.collectionChanged.raise(cv.sortDescriptions)
  }

  function itemsToJson (items) {
    const inputFields = {
      serial_no: { type: 'string' },
      name: { type: 'string' },
      price: { type: 'number', decimalPlace: 0 },
      rate: { type: 'number', decimalPlace: 2 },
      royality: { type: 'number', decimalPlace: 2 },
      stamp_notice: { type: 'string' },
      ratio_stamp: { type: 'number', decimalPlace: 0 },
      ratio_item: { type: 'number', decimalPlace: 0 },
      comment: { type: 'string' }
    }

    const inputs = items.map((item) => {
      const input = {}
      Object.keys(inputFields).forEach((field) => {
        const format = inputFields[field]
        if (format.type === 'number') {
          const pow = Math.pow(10, format.decimalPlace)
          input[field] = Math.round(item[field] * pow) / pow
        } else {
          input[field] = item[field]
        }
      })
      return input
    })

    return JSON.stringify(inputs)
  }

  useEffect(() => {
    // 最初だけ実行

    const oldItems = props.oldItemsJson.map((item) => {
      item.rate_decimal = Number(item.rate) / 100
      delete item.rate
      delete item.ratio_stamp

      // royalityがデータ上にある場合、priceの小数点以下を調整して整合性が取れるようにする
      if ('royality' in item) {
        item.price = getNearestPrice(item.price, item.rate_decimal, item.royality)
        delete item.royality
      }

      return item
    })

    const getError = (item, propName) => {
      if (['price'].includes(propName)) {
        if (item.price < 0.5) {
          return '税抜小売価格には1円以上を指定してください。'
        }
      }
      if (['price', 'royality'].includes(propName)) {
        // testRoyality: 見た目で（＝価格が四捨五入された値で）計算された使用料
        const testRoyality = Math.round(multiplyDecimals(Math.round(item.price), item.rate_decimal * 100, 0, 2)) / 100
        if (Math.abs(item.royality - testRoyality) > 0.001) {
          return `使用料単価が整数での計算値（￥${testRoyality.toFixed(2)}）と異なる可能性があります。このままでも申請可能ですがよくご確認ください。`
        }
      }
      return null
    }
    const _newItemsCV = new wjCore.CollectionView(oldItems, {
      canAddNew: props.mode === 'register',
      canRemove: props.mode === 'register',
      calculatedFields: {
        rate: (obj) => obj.rate_decimal * 100,
        royality: (obj) => Math.round(obj.price * obj.rate_decimal * 100) / 100,
        ratio_stamp: (obj) => obj.stamp_notice === '免除' || obj.stamp_notice === '印刷' ? 0 : 1,
        name_length: (obj) => Encoding.convert(Encoding.stringToCode(obj.name ?? ''), { to: 'SJIS', from: 'UNICODE' }).length / 2,
        comment_length: (obj) => obj.comment?.length ?? 0
      },
      getError: getError
    })

    _newItemsCV.collectionChanged.addHandler((cv, e) => {
      // アイテム情報のJSONを隠し要素に記録（フォーム送信時に参照する）
      if (jsonElem) {
        jsonElem.val(itemsToJson(_newItemsCV.items))
      }
    })
    _newItemsCV.collectionChanged.raise(_newItemsCV)
    setNewItemsCV(_newItemsCV)

    const _layoutDef = getLayoutDef(props.mode, _newItemsCV, props.stampNoticeOptions, stampId)
    setLayoutDef(_layoutDef)

    if (props.mode === 'register' && oldItems.length === 0) {
      addItem(_newItemsCV)
    }
  }, [])

  function getIsEditable (item, column) {
    if (column.binding === 'ratio_item') {
      return item.stamp_notice === '代表'
    } else {
      return true
    }
  }

  // 要注意項目の判定関数
  function getIsWarningField (item, column) {
    if (column.binding === 'rate_decimal') {
      return item.rate_decimal !== contract.rate * 0.01
    } else if (column.binding === 'stamp_notice') {
      return item.stamp_notice !== '通常'
    } else if (column.binding === 'ratio_item') {
      return item.ratio_item !== 1
    } else if (column.binding === 'ratio_stamp') {
      return item.ratio_stamp !== 1
    } else {
      return false
    }
  }

  const gridInit = (grid) => {
    grid.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        const item = e.getRow().dataItem
        const column = grid.getBindingColumn(e.panel, e.row, e.col)
        // 編集不可の行のスタイル変更
        if (e.cell.classList.contains('wj-style-green-input')) {
          if (!getIsEditable(item, column)) {
            wjCore.removeClass(e.cell, 'wj-style-green-input')
            wjCore.addClass(e.cell, 'wj-style-green')
          }
        }
        // 要注意項目のスタイル設定
        if (getIsWarningField(item, column)) {
          wjCore.addClass(e.cell, 'text-danger')
          wjCore.addClass(e.cell, 'font-weight-bold')
        }
      }
    })

    grid.beginningEdit.addHandler((s, e) => {
      const item = e.getRow().dataItem
      const column = grid.getBindingColumn(e.panel, e.row, e.col)
      if (!getIsEditable(item, column)) {
        e.cancel = true
      }
    })

    grid.cellEditEnding.addHandler((s, e) => {
      const column = s.getBindingColumn(e.panel, e.row, e.col)
      if (column.binding === 'name') {
        // タブ文字・改行を削除
        const value = grid.activeEditor.value?.replaceAll(/[\t\r\n]/ig, '')
        if (value !== grid.activeEditor.value) {
          grid.activeEditor.value = value
        }
        const converted = Encoding.convert(Encoding.stringToCode(value), { to: 'SJIS', from: 'UNICODE' })
        if (converted.length > 60) {
          alert('商品名は全角30文字/半角60文字以内で入力してください。')
        }
      } else if (column.binding === 'stamp_notice') {
        if (grid.activeEditor.value !== '代表') {
          // 掛率数量をリセット
          grid.setCellData(e.row, e.col + 3, 1)
        }
      } else if (column.binding === 'rate_decimal') {
        // 料率変更時に小数の小売価格を四捨五入する
        // ※使用料単価を調整したアイテムを編集した際、小売価格がそのままだと計算が合わないように見えるため
        const beforeRate = e.data * 100
        let afterRate = Number(grid.activeEditor.value.slice(0, -1))
        if (!Number.isNaN(afterRate)) {
          afterRate = Math.round(afterRate * 100) * 0.01
          if (Math.abs(beforeRate - afterRate) >= 0.01) {
            const price = grid.getCellData(e.row, e.col - 1)
            if (price % 1 !== 0) {
              grid.setCellData(e.row, e.col - 1, 0)
            }
          }
        }
      }
    })

    // インポート時に入力値をチェックする
    grid.collectionView.sourceCollectionChanged.addHandler((cv) => {
      let changed = false
      const newItem = cv.items.map((item) => {
        // タブ文字・改行を削除
        item.name = item.name.replaceAll(/[\t\r\n]/ig, '')
        const converted = Encoding.convert(Encoding.stringToCode(item.name), { to: 'SJIS', from: 'UNICODE' })
        if (converted.length > 60) {
          alert('商品名は全角30文字/半角60文字以内で入力してください。')
        }
        if (stampId === '000' && item.stamp_notice !== '印刷') {
          item.stamp_notice = '印刷'
          changed = true
        }
        if (stampId === '999' && item.stamp_notice !== '免除') {
          item.stamp_notice = '免除'
          changed = true
        }
        if (!['通常', '印刷', '免除', '代表'].includes(item.stamp_notice)) {
          item.stamp_notice = '通常'
          changed = true
        }
        if (item.stamp_notice !== '代表' && item.ratio_item !== 1) {
          item.ratio_item = 1
          changed = true
        }
        return item
      })
      if (changed) {
        cv.sourceCollection = newItem
        cv.collectionChanged.raise(cv)
      }
    })

    // 内部的に小数を含む列（税抜小売価格）をコピーした際に内部値をコピーするための処理
    grid.copying.addHandler((cv, e) => {
      const range = e.range
      for (let col = range.leftCol; col <= range.rightCol; col++) {
        for (let row = range.topRow; row <= range.bottomRow; row++) {
          const column = grid.getBindingColumn(e.panel, row, col)
          if (column.binding === 'price') {
            column.format_tmp = column.format
            column.format = null
          }
        }
      }
    })
    grid.copied.addHandler((cv, e) => {
      const range = e.range
      for (let col = range.leftCol; col <= range.rightCol; col++) {
        for (let row = range.topRow; row <= range.bottomRow; row++) {
          const column = grid.getBindingColumn(e.panel, row, col)
          if (column.binding === 'price') {
            column.format = column.format_tmp
            column.format_tmp = null
          }
        }
      }
    })

    grid.tableFormat = tableFormat

    customContextMenu(grid)
    editableFlexGridInitialize(grid)
  }

  return (
    layoutDef && (
      <div className="d-inline-block w-100 text-center">
        <div className="d-inline-block mw-100">
          <div className="w-100 text-left">
            {props.mode === 'register' && (
              <>
                <button className="btn bg-theme-primary mb-1" type="button" onClick={(e) => addItem(newItemsCV)}>
                  <AddIcon />
                  <span className='align-middle'>新規アイテムを追加</span>
                </button>
                <FlexGridFileImport
                  tableFormat={tableFormat}
                  collectionView={newItemsCV}
                  className='float-right mb-0 ml-2'
                />
              </>
            ) }
          </div>
          <wjMultiRow.MultiRow showMarquee={true} itemsSource={newItemsCV} layoutDefinition={layoutDef.def} keyActionTab={KeyAction.Cycle}
            frozenColumns={layoutDef.frozenColumns} multiRowGroupHeaders={true} initialized={gridInit} validateEdits={false}>
          </wjMultiRow.MultiRow>
        </div>
      </div>
    )
  )
}

ItemsRegisterGrid.propTypes = {
  contract: PropTypes.object,
  mode: PropTypes.string,
  itemsJsonId: PropTypes.string,
  oldItemsJson: PropTypes.arrayOf(PropTypes.object),
  stampId: PropTypes.string,
  stampNoticeOptions: PropTypes.arrayOf(PropTypes.string)
}

ItemsRegisterGrid.defaultProps = {
  itemsJsonId: '',
  oldItemsJson: [],
  stampId: '',
  stampNoticeOptions: ['通常', '印刷', '免除', '代表']
}

$('#items-register-grid').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <ItemsRegisterGrid {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
